import React, { FunctionComponent } from 'react';
import { Redirect } from 'react-router-dom';
import { useAvailableIntegration } from '../hooks/useAvailableIntegration';
import { AppType } from '../services/models/app-type';

/**
 * Verify that the specified AppType is an available integration for the current account.
 * It redirects to the default route if the app is not an availabe integration.
 */
const withAvailableIntegration = <P extends object>(
  appType: AppType,
  Component: React.ComponentType<P>
) => {
  const WithAvailableIntegration: FunctionComponent = props => {
    const { ...remainingProps } = props;

    const isAvailable = useAvailableIntegration(appType);

    if (isAvailable) {
      return <Component {...(remainingProps as P)} />;
    }

    return <Redirect to="/"></Redirect>;
  };

  return WithAvailableIntegration;
};

export default withAvailableIntegration;
